import { useEffect, useState } from "react";
import { api } from "./api";

export type LoadState = "loading" | "ready" | "notfound";

/** Fetch a single listing from the live API; fall back to the seeded mock by id;
 *  report "notfound" only when neither has it. */
export function useListing<T extends { id: string }>(
  kind: "people" | "services" | "companies" | "jobs" | "projects" | "rfqs",
  id: string,
  mockList: T[],
): { item: any | null; state: LoadState } {
  const [item, setItem] = useState<any | null>(null);
  const [state, setState] = useState<LoadState>("loading");

  useEffect(() => {
    let alive = true;
    setState("loading");
    setItem(null);
    const mock = () => mockList.find((x) => x.id === id) || null;
    api.getListing(kind, id)
      .then((it) => {
        if (!alive) return;
        const resolved = it || mock();
        if (resolved) { setItem(resolved); setState("ready"); }
        else { setItem(null); setState("notfound"); }
      })
      .catch(() => {
        if (!alive) return;
        const m = mock();
        if (m) { setItem(m); setState("ready"); }
        else { setState("notfound"); }
      });
    return () => { alive = false; };
  }, [kind, id]); // eslint-disable-line react-hooks/exhaustive-deps

  return { item, state };
}
